import type { CredentialExpiryStatus } from '@seek/ca-graphql-schema/types';
import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';

import translations from './.vocab';
export const useGetLicenceExpiryStatusBadge = (
  credentialExpiryStatus?: CredentialExpiryStatus | null,
) => {
  const { t } = useTranslations(translations);

  if (credentialExpiryStatus === 'EXPIRED') {
    return (
      <Badge key="expiredBadge" tone="critical">
        {t('Expired')}
      </Badge>
    );
  } else if (credentialExpiryStatus === 'EXPIRING_SOON') {
    return (
      <Badge key="expiringSoonBadge" tone="caution">
        {t('Expiring soon')}
      </Badge>
    );
  }
  return undefined;
};
